import { subscribe, unsubscribe, ready } from "@payloadcms/live-preview";
import { useCallback, useEffect, useState, useRef } from "react";

export const useLivePreview = ({ depth = 0, initialData, serverURL }) => {
  const [data, setData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(true);
  const hasSentReadyMessage = useRef(false);
  const [isIframeOrPopup, setIsIframeOrPopup] = useState(false);

  console.log("isIframeOrPopup", isIframeOrPopup);

  useEffect(() => {
    if (window.opener || window.parent !== window) {
      // Popup windows have an opener
      setIsIframeOrPopup(true);
    } else {
      // Regular browser tab
      setIsIframeOrPopup(false);
    }
  }, []);

  const onChange = useCallback((mergedData) => {
    setData(mergedData);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    // Get the admin panel URL from the referrer or serverURL

    if (isIframeOrPopup) {
      const adminPanelURL = serverURL;

      const subscription = subscribe({
        callback: onChange,
        depth,
        initialData,
        serverURL: adminPanelURL, // Use admin panel URL here
      });

      if (!hasSentReadyMessage.current) {
        hasSentReadyMessage.current = true;
        ready({
          serverURL: adminPanelURL, // Use admin panel URL here
        });
      }

      return () => {
        unsubscribe(subscription);
      };
    } else {
      console.log("DATA", initialData);
      setIsLoading(false);
      setData(initialData);
    }
  }, [serverURL, onChange, depth, initialData]);

  return {
    data,
    isLoading,
  };
};
